<template>
  <div
    class="rates rates1 rates--1 lp-section width-expand"
    :id="`Rates1-${pageUid}`">
    <drawer v-model="isOpened" location="bottom" class="bg-bg-4">
      <template #default>
        <div class="rates1 container container-s margin-inline-auto ">
          <div class="title-block">
            <h3 class="text-center title-block">{{ title }}</h3>
          </div>
          <div class="text-block text-l text-center">
            <content-blocks :content="text?.blocks"></content-blocks>
          </div>

          <div class="rates-block  margin-2xl-vertical  bg-bg border-radius">
            <div class="rate-group "
                 :class="{'active' : isActiveGroup(groupIndex)}"

                 v-for="(rateGroup, groupIndex) of rateGroups">
              <div class="rate-header width-expand flex-between flex-middle gap-2xl cursor-pointer padding-m-horizontal"
              @click="setGroup(groupIndex)">
                <h4 class="text margin-remove text-xl">
                  {{rateGroup.title}}
                </h4>
                <div class="icon-container flex-middle">
                    <icon class="animate__fadeIn animate--fastest" theme="lead" size="2" :icon="'minus'" v-show="isActiveGroup(groupIndex)"></icon>
                  <icon class="animate__fadeIn animate--fastest" theme="lead" size="2" :icon="'plus'" v-show="!isActiveGroup(groupIndex)"></icon>
                </div>
              </div>
              <div class="rate-content animate__fadeInDownSmall animate--faster bg-lead c-bg padding-m" v-show="isActiveGroup(groupIndex)">
                <div class="rates">
                  <div class="rate margin-s-bottom flex flex-between width-expand relative" v-for="rate in rateGroup.rates">
                    <div class="rate-text bg-lead relative z-level-2">{{rate.text}}</div>
                    <div class="rate-rate bg-lead relative z-level-2">{{rate.rate}}</div>
                  </div>
                  <hr class="bg-bg margin-l-top" v-if="isNonEmptyString(rateGroup.smallPrint)">
                  <p class="text-s">
                    {{rateGroup.smallPrint}}
                  </p>
                </div>
              </div>
            </div>
          </div>
         <div class="post-text-block">
           <content-blocks :content="postText?.blocks"></content-blocks>
         </div>

          <div class="close-container flex-middle flex-center margin-l-top">
            <form-button
              theme="inverse"
              text="lp.sections.rates1.close"
              @click="isOpened = false"></form-button>
          </div>
        </div>

      </template>
    </drawer>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      text: {},
      rateGroups: [
        {
          title: "",
          rates: [
            {
              text: "",
              rate: "",
            },
          ],
          smallPrint: "",
        },
      ],
      postText: {},
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {
      isOpened: false,
      currentGroupIndex: -1,
    };
  },
  computed: {},
  methods: {
    setGroup(index) {
      if (this.currentGroupIndex === index) {
        this.currentGroupIndex = -1;
      } else {
        this.currentGroupIndex = index;
      }
    },
    isActiveGroup(index) {
      return this.currentGroupIndex === index;
    },
    requestRatesOpenHandler(e) {
      console.log("detected open request", e);
      this.isOpened = true;
    }
  },
};
</script>

<style scoped lang="scss">
.rates1 {
  .title-block {
    margin-bottom: calc(var(--margin-max) * 0.7);
    font-weight: 600;

    @media (max-width: 1024px) {
      margin-bottom: calc(var(--margin-max) * 0.6);
    }
  }

  .text-block {
    :deep(p) {
      font-size: var(--text-l);
    }
  }

  .rate-group{
    position: relative;
    padding-top: var(--margin-l);
    padding-bottom: var(--margin-l);

    &::after {
      position: absolute;
      content: " ";
      height: 2px;
      width: 100%;
      background-color: var(--c-gray-2);
      top: calc(100%  - 1px);
    }

    &:last-of-type {
      border-bottom: none;

      &::after {
        display: none;
      }

    }

    &.active {
      padding-bottom: 0;

      .rate-header {
        font-weight: bold;
        color: var(--c-alt);
        padding-bottom: var(--margin-l);

        &::after {
          display: none;
        }

      }
    }


  }

  .rate {
    .rate-text {
      padding-inline-end: var(--margin-m);
    }
    .rate-rate {
      padding-inline-start: var(--margin-m);
    }
    &::after {
      position: absolute;
      content: " ";
      height: 3px;
      border-bottom: 2px dotted var(--c-bg);
      top: calc(100% - 8px);
      width: 100%;
      z-index: var(--z-1);
    }
  }
}
</style>
